import React, { CSSProperties, FC, RefObject } from "react";
import { ColorPicker as ColorPickerUI, IColorPickerProps } from "@evergis/ui";
import { Color } from "@evergis/color";

import { ColorContainer } from "../styled";

export const ColorPicker: FC<
  Omit<IColorPickerProps, "value"> & { value: string; style?: CSSProperties; innerRef?: RefObject<HTMLDivElement> }
> = ({ value, style, innerRef, ...props }) => (
  <ColorContainer style={style} ref={innerRef}>
    <ColorPickerUI {...props} value={new Color(value)} />
  </ColorContainer>
);
